// @ts-check
const dbName = 'sportbook';

/**
 * @readonly
 * @enum {string}
 */
export const OBJECT_STORES = {
  IMAGES: 'images'
};


export class IndexedDbService {
  /**
   * Initalize service with object store name
   * @param {OBJECT_STORES} storeName 
   */
  constructor(storeName) {
    this.storeName = storeName;
    this.db = null;
  }
  /**
   * Opens the db connection and updates db scheme if there are changes
   */
  openDb() {
    return new Promise((res, rej) => {
      let request = indexedDB.open(dbName, 1);
      request.onerror = (evt) => {
        rej(evt.target.errorCode); // eslint-disable-line
      };
      request.onupgradeneeded = (_event) => {
        this.db = request.result;
        if (!this.db.objectStoreNames.contains(OBJECT_STORES.IMAGES)) {
          this.db.createObjectStore(OBJECT_STORES.IMAGES, { keyPath: 'id' });
        }
      };
      request.onsuccess = () => {
        this.db = request.result;
        res();
      };
    });
  }
  /**
   * Get object store reference
   */
  getStore() {
    let transaction = this.db.transaction(this.storeName, "readwrite");
    let imageStore = transaction.objectStore(this.storeName);
    return imageStore;
  }
  /**
   * Add an item to the store
   * @param {*} item - Item to be added should contain keyPath property specified in createObjectStore
   */
  addItem(item) {
    return new Promise((res, rej) => {
      const store = this.getStore();
      let request = store.add(item);
      request.onerror = (_event) => {
        rej('Failed to add item');
      };
      request.onsuccess = (_event) => {
        res();
      };
    });
  }
  /**
   * Get item from the store 
   * @param {*} key - Key of the item
   */
  getItem(key) {
    return new Promise((res, rej) => {
      const store = this.getStore();
      let request = store.get(key);
      request.onerror = (_event) => {
        rej(`Failed to get item with key ${key}`);
      };
      request.onsuccess = (_event) => {
        res(request.result);
      };
    });
  }
  /**
   * Update existing item in store
   * @param {*} key - Key of the item
   * @param {*} item - Item to update to
   */
  updateItem(key, item) {
    return new Promise((res, rej) => {
      this.getItem(key).then(dbItem => {
        let newItem = { ...dbItem, ...item };
        const store = this.getStore();
        let request = store.put(newItem);
        request.onerror = (_event) => {
          rej(`Failed to updated item with key ${key}`);
        };
        request.onsuccess = (_event) => {
          res();
        };
      }).catch(err => { rej(err); });
    });
  }
  /**
   * Delete item from store
   * @param {*} key - Key of the item
   */
  deleteItem(key) {
    return new Promise((res, rej) => {
      const store = this.getStore();
      let request = store.delete(key);
      request.onerror = (_event) => {
        rej(`Failed to delete item with key ${key}`);
      };
      request.onsuccess = (_event) => {
        res();
      };
    });
  }
  /**
   * Get all items for current store
   * @returns {Promise<any[]>}
   */
  getAllItems() {
    return new Promise((res, rej) => {
      const store = this.getStore();
      let request = store.getAll();
      request.onerror = (_event) => {
        rej('Failed to get all items');
      };
      request.onsuccess = (_event) => {
        res(request.result);
      };
    });
  }
}